import styled from 'styled-components'

export const Loading = styled.div`
    min-height: 47px;
    display: flex;
    flex-grow: 1;
    position: fixed;
    z-index: 501;
    width: calc(100% - 270px);
`

export const SimpleLoading = styled.div`
    display: flex;
    flex-grow: 1;
    width: 50px;
    height: 15px;
    background: url(/public/assets/loading-component.gif) no-repeat center center;
`
